const StickyColumnShadow = () => {
  return (
    <div className="absolute h-full right-0 top-0 bg-gradient-to-r from-white to-gray-400 opacity-20 w-2"></div>
  );
};

export default StickyColumnShadow;
